import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useStoreContext } from "@components/store/provider";
import { getMenuCodeMapping } from "@store/selectors/menu";

/**
 * Returns a standardized object containing shop and category details for analytics.
 */
export const useShopAnalyticsContext = () => {
  const {
    category: categoryCode,
    subCategory: subCategoryCode,
    storeNumber,
    pageType,
  } = useStoreContext();
  const menuCodeMapping = useSelector(getMenuCodeMapping);

  return useMemo(() => {
    const categoryItem = menuCodeMapping?.[categoryCode];
    const subCategoryItem = menuCodeMapping?.[subCategoryCode];

    return {
      shop_number: storeNumber,
      category_id: categoryItem?.id,
      category_code: categoryCode,
      category_name: categoryItem?.name,
      subcategory_id: subCategoryItem?.id,
      subcategory_code: subCategoryCode,
      subcategory_name: subCategoryItem?.name,
      page_type: pageType,
    };
  }, [storeNumber, categoryCode, subCategoryCode, menuCodeMapping, pageType]);
};
